import { useTranslation } from '../../lib/i18n';
import { Language } from '../../lib/i18n/types';
import { cn } from '../../lib/utils';

const languages: { code: Language; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'zh', label: '中文' },
];

export const LanguageSelector = () => {
  const { language, setLanguage } = useTranslation();

  return (
    <div className="flex items-center rounded-[70px] border border-white/40 bg-[#3B3B3B1A] backdrop-blur-sm overflow-hidden">
      {languages.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => setLanguage(code)}
          className={cn(
            'px-4 py-2 text-sm font-minion transition-all',
            language === code
              ? 'bg-white/20 text-white'
              : 'text-white/60 hover:text-white/80',
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
};
